import logo from "../assets/logo.png";
export { logo };

export const FILTER = {
  page: 1,
  limit: 10,
};

export const PAGINATION = {
  ...FILTER,
  totalPages: 1,
  total: 0,
};

export const ROLE = {
  assistant: "Trợ lý sự kiện",
  staff: "Cộng tác viên",
  user: "Thành viên",
};

export const GENDER = {
  male: "Nam",
  female: "Nữ",
  other: "Khác",
};

export const eventTypeList = [
  {
    label: "Khóa tu",
    value: "khoa-tu",
  },
  {
    label: "Khóa học",
    value: "khoa-hoc",
  },
  {
    label: "Hoa đăng",
    value: "hoa-dang",
  },
  {
    label: "Quy y Tam Bảo",
    value: "quy-y-tam-bao",
  },
  {
    label: "Tổng kết",
    value: "tong-ket",
  },
  {
    label: "Thiền trà",
    value: "thien-tra",
  },
];

export const mappingEventType = {
  "khoa-hoc": "Khóa học",
  "khoa-tu": "Khóa tu",
  "hoa-dang": "Hoa đăng",
  "quy-y-tam-bao": "Quy y Tam Bảo",
  "tong-ket": "Tổng kết",
  "thien-tra": "Thiền trà",
};

export const REFUGE_CEREMONY_OPTIONS = [
  {
    label: "QYNX",
    value: "QYNX",
  },
  { label: "QYPĐ", value: "QYPĐ" },
  { label: "QYVL", value: "QYVL" },
];
